import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_LOG_ACTIVITY,
  FETCH_LOG_AGENT,
  M_POST,
} from '@/utils/api';

import { IfetchActivity } from '@/interface/Activity';

import Vue from 'vue';

@Module({ name: 'activity' })
export default class Activity extends VuexModule {
  @Action
  FetchActivityLog(params: IfetchActivity) {
    return Vue.axios({
      url: BASE_URL + FETCH_LOG_ACTIVITY,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchActivityLogAgent(criteria) {
    return Vue.axios({
      url: BASE_URL + FETCH_LOG_AGENT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }
}
